module.exports = __webpack_public_path__ + "media/images/header-separate-line-e8cded6ed03458bd5448c3fe8c73fffd.png";